export const LEARN_MORE_PRE_REGISTER_SECTION_ID = 'pre-register';
export const LEARN_MORE_HEADER_SECTION_ID = 'header';
